/**
 * 请注意：不要修改模型中的任何字段名
 * 此处使用了后端的不要脸端口
 * 后端不负责定义字段
 * 完全根据前端传参存取
 * */

/**
 * 个性化管理
 * @description 功能模型
 */

import { getConfig } from '@/api/config'

const CONFIG_GROUP = 'TouchCustomization'

export default class Customization {
    /** 主键 ID */
    id
    /** 自定义个性化展示文案 */
    project
    /** 个性化宣传文案 */
    bannerText
    /** 渠道 ID */
    channelId
    /** 小高渠道 ID */
    highChannelId
    /** 活动 Code */
    activityCode
    /** 启用状态 */
    enabled

    constructor (data = {}) {
        this.id = data.id
        this.project = data.project
        this.bannerText = data.bannerText
        this.channelId = data.channelId
        this.highChannelId = data.highChannelId
        this.activityCode = data.activityCode
        this.enabled = data.enabled
    }

    /** 获取个性化配置详情 */
    static async get (id) {
        let response = await getConfig({
            group: CONFIG_GROUP,
            key: id
        })
        return new Customization(JSON.parse(response.data.value))
    }
}
